import React from 'react'
import Buy from './Buy'

const Instant_Buy_Sell = () => {
  return (
    <div>

        
<Buy/>


    </div>
  )
}

export default Instant_Buy_Sell